<template>
  <div v-if="show" class="beta-control-container">
    <!-- 过期 -->
    <div v-if="expired" :class="{ 'is-unfold': isUnfold }" class="beta beta-expired">
      <span class="status">Expired</span>
    </div>
    <div v-else-if="isUnfold">
      <AppLink
        v-if="$checkPermission(['admin', 'diamond'])"
        to="/setting/subscription-and-billing-v2/manage"
        class="beta-unfold"
      >
        <span class="status">{{ timeLeft }} left</span>
        <span class="buy-btn">
          Check
          <svg-icon class="buy-icon" name="ic-left-more"></svg-icon>
        </span>
      </AppLink>
      <div v-else class="beta-unfold">
        <span class="status">{{ timeLeft }} left</span>
      </div>
    </div>
    <div v-else class="beta beta-closure">
      <span class="status">Beta</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AppLink from './link.vue'
export default {
  name: 'BetaControl',
  components: { AppLink },
  props: {
    isUnfold: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      demoType: state => state.user.demoType,
      expireDate: state => state.user.expireDate,
      expiredDemoAccount: state => state.user.expiredDemoAccount,
      expiredTrialAccount: state => state.user.expiredTrialAccount
    }),
    timeLeft() {
      let interval = (new Date(this.expireDate).getTime() - Date.now()) / (24 * 60 * 60 * 1000)
      interval = Math.round(interval);
      if (interval > 1) return `${interval} days`;
      return `${interval} day`;
    },
    show() {
      // beta过期还未延长15天
      if (this.demoType === 'demo' && this.expiredDemoAccount) return true
      // beta延长15天后
      if (this.demoType === 'demo_trail') return true
      return false
    },
    expired() {
      if (this.demoType === 'demo' && this.expiredDemoAccount) return true
      if (this.demoType === 'demo_trail' && this.expiredTrialAccount) return true
      return false
    }
  },
}
</script>
<style lang="scss" scoped>
.beta-control-container {
  // margin-top: 12px;
  width: 100%;
  height: 36px;
  padding: 0px 12px 10px;
  background: #001c4f;
  .beta {
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    .status {
      font-family: OpenSans-Bold, sans-serif;
      font-size: 12px;
      color: #fff;
    }
  }
  .beta-expired {
    margin: 0 -7px;
    background-color: #cc581d;
    &.is-unfold {
      margin: 0;
    }
  }
  .beta-closure {
    background-color: #0abc4e;
  }
  .beta-unfold {
    padding: 5px 10px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    background-color: #0abc4e;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
    .status {
      flex: 1;
      font-family: OpenSans-Bold, sans-serif;
      font-size: 12px;
      color: #fff;
    }
    .buy-btn {
      flex-shrink: 0;
      margin-left: 5px;
      display: flex;
      align-items: center;
      font-family: OpenSans-Bold, sans-serif;
      font-size: 12px;
      color: #fff;
      .buy-icon {
        flex-shrink: 0;
        font-size: 12px;
      }
    }
  }
}
</style>
